export function formatDate(date) {
  let adjustedDate = [new Date(date.startDate), new Date(date.endDate)]
  return adjustedDate.map((e) => {
    let yyyy = e.getFullYear()
    let mm = String(e.getMonth() + 1).padStart(2, '0') // Los meses van de 0 a 11, así que agregamos 1
    let dd = String(e.getDate()).padStart(2, '0')
    return `${yyyy}-${mm}-${dd}`
  })
}

export function parseDate(date){
 return Date.parse(date + 'T00:00:00')
}

module.export = {formatDate , parseDate}